import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeletePipelineTemplateMutation} from '../hooks/usePipelineTemplatesQuery';
import {usePipelineTemplatesSelection} from "../hooks/usePipelineTemplatesSelection.ts";


export const DeleteRecordButton = () => {

    const deletePipelineTemplateMutation = useDeletePipelineTemplateMutation();

    const {
        selection,
        handleClearSelection,
    } = usePipelineTemplatesSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deletePipelineTemplateMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
